import { isPast, parseISO } from "date-fns";
import { dropWhile as _dropWhile, isString as _isString, takeWhile as _takeWhile, throttle as _throttle } from "lodash-es";
import { stringifyObjects } from "./stringify";
export function useConsole({
  fn,
  process,
  action,
  messages,
  stringify: shouldStringify = true
}) {
  const [message, additionalData] = extractStringPrefix(...messages);
  console[fn](`[${process}#${action}] ${message}`, ...(shouldStringify ? additionalData.map(stringifyObjects) : additionalData));
}
const sessionFromSessionStorage = _throttle(() => getCurrentSessionFromSessionStorage(), 500);
function getCurrentSessionFromSessionStorage() {
  let session;
  try {
    session = JSON.parse(window.sessionStorage.getItem("currentSession") || window.localStorage.getItem("currentSession") || "null");
  } catch (e) {
    session = undefined;
  }
  if (!session || isPast(parseISO(session.expiresAt))) {
    return undefined;
  }
  return session;
}
export function initializeWindowOnErrorHandler({
  error: reportError
}) {
  if (typeof window !== "undefined") {
    window.onerror = (message, source, lineno, colno, error) => {
      reportError("onerror", "Error reached window", {
        error: {
          message,
          error,
          source,
          lineno,
          colno
        }
      });
    };
  }
}
export function lookupCashierId() {
  const storedSession = sessionFromSessionStorage();
  if (!storedSession) {
    return undefined;
  }
  return storedSession.personId;
}
export function lookupCashierUserName() {
  const storedSession = sessionFromSessionStorage();
  if (!storedSession) {
    return undefined;
  }
  return storedSession.userName;
}
export function lookupDeviceId() {
  const storedSession = sessionFromSessionStorage();
  return typeof window !== "undefined" && window.device && window.device.uuid || storedSession && storedSession.deviceId || "Unknown";
}
export function lookupDeviceName() {
  const storedSession = sessionFromSessionStorage();
  return typeof window !== "undefined" && window.device && window.device.uuid || storedSession && storedSession.deviceId || "Unknown";
}
export function lookupStoreInfo() {
  const storedSession = sessionFromSessionStorage();
  if (!storedSession) {
    return {};
  }
  return {
    storeId: storedSession.storeId,
    storeNumber: storedSession.storeNumber
  };
}
function extractStringPrefix(...messages) {
  const message = _takeWhile(messages, _isString).join(" ");
  const additionalData = _dropWhile(messages, _isString);
  return [message, additionalData];
}
